import { useLang } from "@/i18n/LanguageContext";
import { SUPPORT_CONTENT } from "@/i18n/supportContent";
import LegalDocumentPage from "@/components/legal/LegalDocumentPage";

export default function Support() {
  const { lang } = useLang();
  const content = SUPPORT_CONTENT[lang] || SUPPORT_CONTENT.es;

  return <LegalDocumentPage content={content} testId="support-page" />;
}
